define(function(require) {
	const d3 = require('d3c');
	const updateColor = "#a8a8a8"; // @portal-color-updating

	return function(dataType, settings) {
		const data = [];

		if (dataType === "barChartHorizontal") {
			for (let i = 0; i < 3; i++) {
				const obj = {
					id: "dummy" + (i + 1),
					color: updateColor,
					dummy: true,
					shareOfVoice: 1 - 0.25 * i,
					frequencyTotal: 10 - 2.5 * i,
					impact: 10 - 2.5 * i,
					sentimentMean: 1 - 0.25 * i,
					sentimentStdDev: 1 - 0.25 * i,
					keywords: [{},{},{}]
				};

				data.push(obj);
			}
		} else if (dataType === "barChartVertical") {
			for (let i = 0; i < 3; i++) {
				const obj = {
					id: "dummy" + (i + 1),
					color: updateColor,
					dummy: true,
					shareOfVoice: 1 - 0.25 * i,
					shareOfVoiceDeviation: 1 - 0.25 * i,
					frequencyTotal: 10 - 2.5 * i,
					frequencyTotalDeviation: 1 - 0.25 * i,
					impact: 10 - 2.5 * i,
					impactDeviation: 1 - 0.25 * i,
					sentimentMean: 1 - 0.25 * i,
					sentimentMeanDeviation: 1 - 0.25 * i,
					sentimentStdDev: 1 - 0.25 * i,
					sentimentStdDevDeviation: 1 - 0.25 * i,
					sentimentFrequency: 1 - 0.25 * i
				};

				data.push(obj);
			}
		} else if (dataType === "clustermapGroups") {
			for (let i = 0; i < 2; i++) {
				const obj = {
					key: "dummy" + (i + 1),
					keywords: [],
					clusterMaxRadius: 0
				};

				data.push(obj);
			}
		} else if (dataType === "clustermapNodes") {
			for (let i = 0; i < 2; i++) {
				for (let j = 0; j < 3; j++) {
					const obj = {
						cluster: "dummy" + (i + 1),
						color: updateColor,
						updateColor,
						reach: (j + 1) / 10,
						x: 60 * i + 10 * j,
						y: 40 * i + 10 * j
					};

					data.push(obj);
				}
			}
		} else if (dataType === "donutChart") {
			for (let i = 0; i < 3; i++) {
				const obj = {
					id: "dummy" + (i + 1),
					color: updateColor,
					updateColor: updateColor,
					dummy: true,
					percentage: ""
				};
				obj[settings.dataAttr] = 1;

				data.push(obj);
			}
		} else if (dataType === "storyGraph") {
			const shiftTime = settings.shiftDate(settings.beginDate, 3).getTime() <= settings.endDate.getTime() ? settings.shiftDate : settings.shiftHour;

			for (let i = 0; i < 3; i++) {
				const obj = {
					id: "dummy" + (i + 1),
					color: d3.rgb(updateColor).darker(i),
					dummy: true,
					episodeDescription: [],
					episodeID: "dummyEpisode" + (i + 1),
					episodeFrom: settings.beginDate,
					episodeTo: settings.endDate,
					datapoints: []
				};

				let newDate = new Date(settings.beginDate);
				while (newDate.getTime() <= settings.endDate.getTime()) {
					obj.datapoints.push({
						beginDate: newDate.getTime(),
						date: newDate,
						id: "dummy" + (i + 1),
						weight: Math.floor(Math.random() * 100 * (i + 1)) + 10 * (i + 1),
						docCount: 1
					});

					newDate = shiftTime(newDate, 3);
				}

				data.push(obj);
			}
		} else if (dataType === "tagcloud") {
			for (let i = 0; i < settings.tagLines; i++) {
				const tagsPerLine = i % 2 === 0 ? 5 : 3; // 5 tags in an even line, 3 tags in an odd line
				const tagWidth = (settings.width - settings.marginH * 2 - settings.paddingH * (tagsPerLine - 1)) / tagsPerLine;

				for (let j = 0; j < tagsPerLine; j++) {
					data.push({
						linenumber: i,
						tagnumber: j,
						width: tagWidth,
						height: settings.tagHeight
					});
				}
			}
		} else if (dataType === "tooltipBarChart") {
			data.push({
				id: "dummy",
				color: updateColor,
				dummy: true,
				dataAttribute: 1
			});
		}

		return data;
	};
});
